

<main id="db-wrapper">
 <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
    <section id="page-content">
        <div class="header">
          <app-only-admin-navigation></app-only-admin-navigation>
        </div>

         <div class="container-fluid p-4" *ngIf="loading">
           <app-header-spinner>

           </app-header-spinner>
           <app-form-spinner></app-form-spinner>
         </div>
        <div class="container-fluid p-4" *ngIf="!loading">
          <div class="row">
            <div class="col-xl-12 mb-3 col-md-12 col-12">
              <div class="bg-primary py-6  px-xl-0 rounded-4 ">
                <div class="row align-items-center">
                  <div class="offset-xl-1 col-xl-5 col-md-6 col-12">
                    <div>
                      <h2 class="h1 text-white mb-3 px-5">Lets Add Blog Post</h2>
                      <p class="text-white fs-4 px-5">
                       Upload and Wait for response
                      </p>
                      
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
           </div>
            <section class="container-fluid">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="card p-6">
                     <div class="card-header">
                       <h2>
                         Add Blog Post with SEO Meta Description
                       </h2>
                     </div>
                     <div class="card-body">
                      <form [formGroup]="form" (ngSubmit)="onSubmit()">
                        <div class="form-group my-2">
                          <div class="text-center">
                            <span class="avatar avatar-xxl  " *ngIf="imageUrl!==''">
                                <img src={{imageUrl}} alt="" class="rounded-circle">
                              </span>
                        </div>

                          </div>
                        <div class="form-group my-2">
                          <label for="Image">Image /Icon for Card:</label><br>
                          <input type="file" (change)="upload($event)" class="form-control" required accept="image/png, image/jpeg, image/webp, image/svg+xml">
                          </div>
                        <div class="form-group my-2">
                          <label for="title">Title</label>
                          <input type="text" id="title" formControlName="title" class="form-control">
                          <div *ngIf="form.get('title')?.hasError('required') && form.get('title')?.touched" class="error-message text-danger">
                            Title is required.
                          </div>
                        </div>

                        <div class="form-group my-2">
                          <label for="metaDescription">Meta Description</label>
                          <textarea id="metaDescription" formControlName="metaDescription" class="form-control"></textarea>
                          <div *ngIf="form.get('metaDescription')?.hasError('required') && form.get('metaDescription')?.touched" class="error-message text-danger">
                            Meta Description is required.
                          </div>
                        </div>
                        <div class="form-group my-2">
                          <label for="description">Description</label>
                          <p-editor formControlName="description" [style]="{ height: '320px' }" />
                          <div *ngIf="form.get('description')?.hasError('required') && form.get('description')?.touched" class="error-message text-danger">
                            Description is required.
                          </div>
                        </div>

                         <div class="row px-2">
                           <button type="submit" [disabled]="form.invalid" class="btn btn-primary">Submit</button>
                         </div>


                      </form>


                     </div>
                    </div>
                  </div>
                </div>

                </section>

      </div>

    </section>
  </main>


